var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.53 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06,12.65c1.46,1.64,3.93,1.64,5.39,0,.4,.25,.74,.58,1.03,.96,.64,.84,.96,1.81,1.09,2.85,.04,.32,.04,.64,.08,.96,.03,.26-.08,.44-.31,.52-.4,.13-.8,.27-1.21,.32-2.31,.32-4.63,.33-6.93-.04-.35-.06-.69-.18-1.03-.3-.22-.08-.3-.25-.29-.49,.03-.98,.18-1.94,.59-2.85,.35-.79,.87-1.45,1.61-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12,6.86c-2,.42-3.09,2.2-2.86,3.96-.02,0-.05,.03-.08,.03-1.73,.08-3.45,.05-5.15-.28-.27-.05-.54-.16-.79-.28-.11-.05-.23-.21-.23-.33-.01-1.14,.18-2.25,.71-3.27,.33-.63,.77-1.15,1.35-1.56,.04-.03,.08-.05,.11-.07,1.51,1.7,4.03,1.55,5.39,0,.69,.45,1.19,1.05,1.55,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.39,6.88c.36-.77,.87-1.36,1.56-1.83,.72,.79,1.61,1.23,2.68,1.23,1.08,0,1.97-.43,2.69-1.23,.44,.28,.79,.62,1.08,1.02,.65,.88,.95,1.89,1.06,2.96,.03,.28,.03,.56,.05,.84,.02,.23-.08,.38-.28,.45-.38,.13-.77,.27-1.16,.33-1.57,.25-3.14,.29-4.73,.21-.03,0-.06-.01-.1-.02,.11-.93-.08-1.79-.63-2.56-.55-.76-1.29-1.21-2.23-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76,13.1c-1.52,0-2.76-1.22-2.76-2.74,0-1.52,1.23-2.76,2.75-2.76,1.52,0,2.76,1.23,2.76,2.75,0,1.52-1.22,2.75-2.75,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.63,5.5c-1.52,0-2.75-1.24-2.74-2.76C11.9,1.22,13.13,0,14.65,0c1.52,0,2.75,1.25,2.74,2.76,0,1.52-1.24,2.74-2.77,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62,2.75c0,1.52-1.22,2.75-2.74,2.76-1.52,0-2.76-1.22-2.76-2.74C2.11,1.25,3.35,0,4.86,0c1.52,0,2.75,1.22,2.76,2.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.ffdd932a8de326a0df4cf73e6779489d.svg";
export { ForwardRef as ReactComponent };